import axios from 'axios';
import {config} from '../config';

// Unauthenticated endpoints for the public site (O3-Backend app/routes/public.routes.js).
// Returns { now, live: [...], liveCount, next } — subject, week, times and
// city/country/timezone per side only; no names or ids.
export async function getLiveClasses() {
    const response = await axios.get(`${config.service.host}/api/public/live-classes`);
    return response.data;
}

// { season, places: [{ city, country, timezone }] } — every student country with an
// active class this season, one representative place each.
export async function getSeasonPlaces() {
    const response = await axios.get(`${config.service.host}/api/public/season-places`);
    return response.data;
}
